export default __webpack_public_path__ + "static/media/gift-lifestyle-shops.d658493e.png";